import { jsx as C } from "react/jsx-runtime";
function o(r) {
  return /* @__PURE__ */ C(
    "svg",
    {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...r,
      children: /* @__PURE__ */ C(
        "path",
        {
          d: "M3 6C3 4.93913 3.42143 3.92172 4.17157 3.17157C4.92172 2.42143 5.93913 2 7 2C8.06087 2 9.07828 2.42143 9.82843 3.17157C10.5786 3.92172 11 4.93913 11 6C11 7.06087 10.5786 8.07828 9.82843 8.82843C9.07828 9.57857 8.06087 10 7 10C5.93913 10 4.92172 9.57857 4.17157 8.82843C3.42143 8.07828 3 7.06087 3 6ZM0 17.0719C0 13.9937 2.49375 11.5 5.57188 11.5H8.42813C11.5063 11.5 14 13.9937 14 17.0719C14 17.5844 13.5844 18 13.0719 18H0.928125C0.415625 18 0 17.5844 0 17.0719ZM19.0406 18H14.7344C14.9031 17.7063 15.0031 17.3656 15.0031 17V16.75C15.0031 14.8531 14.1562 13.15 12.8219 12.0063C12.8969 12.0031 12.9688 12 13.0437 12H14.9625C17.7437 12 20 14.2562 20 17.0406C20 17.5719 19.5688 18 19.0406 18ZM13.5 10C12.5312 10 11.6562 9.60625 11.0219 8.97188C11.6375 8.14062 12 7.1125 12 6C12 5.1625 11.7938 4.37188 11.4281 3.67813C12.0094 3.25312 12.725 3 13.5 3C15.4344 3 17 4.56562 17 6.5C17 8.43437 15.4344 10 13.5 10Z",
          fill: "rgb(var(--brand-primary))"
        }
      )
    }
  );
}
export {
  o as PersonalLocationIcon
};
